// @flow
import type {
  RecommendationOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<RecommendationOperation>,
})
